import { Card, Typography } from '@mui/material';
import React from 'react';

function WFHSummaryCardComponent(props) {
  const { wfh, allowedHours, title, availedHours } = props;
  return (
    <Card variant="outlined" className="wfh-card" sx={{ margin: '0' }}>
      <div className="wfh-stat-header" style={{ textAlign: 'center' }}>
        <strong>{title}</strong>
      </div>

      <div className="d-flex justify-content-around">
        <div className="wfh-stat-container">
          <div className="wfh-number available-wfh">
            <Typography align="center" component="div">
              {allowedHours}
            </Typography>
          </div>
          <div className="wfh-stats">Entitled</div>
        </div>

        <div className="wfh-stat-container">
          <div className="wfh-number used-wfh">
            <Typography align="center" component="div">
              {availedHours}
            </Typography>
          </div>
          <div className="wfh-stats">Availed</div>
        </div>

        {/* <div className="wfh-stat-container">
          <div className="wfh-number wfh-days">
            <Typography align="center" variant="h6" component="div">
              {!wfh?.numberOfDaysWorked ? 0 : wfh?.numberOfDaysWorked}
            </Typography>
          </div>
          <div className="wfh-stats">Total WFH Days</div>
        </div> */}
      </div>
    </Card>
  );
}

export default WFHSummaryCardComponent;
